import { restClient } from '@/Core'

import { LOGISTICIANS_INVOLVEMENT_METRICS, LOGISTICIANS_INVOLVEMENT_REPORT_URL } from '../Contracts/ILogisticiansInvolvementReport'
import { reportSearchParams, toNumber, toPeriod, toReportUser, toRows } from '../Helpers/reportResponse'

import type {
    ILogisticiansInvolvementReport,
    ILogisticiansInvolvementRow,
    LogisticiansInvolvementMetric,
} from '../Contracts/ILogisticiansInvolvementReport'
import type { IReportPeriod, IReportSort } from '../Contracts/IReportPeriod'

/**
 * «Звіт по залученню логістів»: `GET /services/reports/logisticians_involvement`
 * (`SPEC-027` §3.3). Без сортування бек віддає рядки в порядку співробітників
 * (`sorting`, потім ПІБ), як легасі.
 */
export const LoadLogisticiansInvolvementReportTask = async (
    period: IReportPeriod,
    sort: IReportSort<LogisticiansInvolvementMetric> | null
): Promise<ILogisticiansInvolvementReport> => {
    const response = (await restClient.get(
        LOGISTICIANS_INVOLVEMENT_REPORT_URL,
        { searchParams: reportSearchParams(period, sort) },
        { forceRefresh: true }
    )) as unknown as Record<string, unknown> | null

    return {
        period: toPeriod(response?.['period'], period),
        rows: toRows(response?.['rows']).map((raw) => {
            const row = (raw ?? {}) as Record<string, unknown>
            const metrics = Object.fromEntries(
                LOGISTICIANS_INVOLVEMENT_METRICS.map((metric) => [metric, toNumber(row[metric])])
            ) as Record<LogisticiansInvolvementMetric, number>

            return { user: toReportUser(row['user']), ...metrics } satisfies ILogisticiansInvolvementRow
        }),
    }
}
